import { observer } from 'mobx-react-lite'
import React from 'react'
import { Dropdown, type IIconsVector } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type Integration } from 'entities/Integrations'
import { useIntegrationListContext } from 'pages/settings/pages/integrations/context/integrationListContext'
import { SettingsRoutes } from 'pages/settings/route/type'
import { IntegrationsRoutes } from 'pages/settings/pages/integrations/route/type'

type IIntegrationListCardActionsProps = {
  integration: Integration
}

const webhookIcon: IIconsVector = 'link'
const settingsIcon: IIconsVector = 'settings2'
const reconnectIcon: IIconsVector = 'refresh'
const unlinkIcon: IIconsVector = 'unlink'

export const IntegrationListCardActions = observer(
  ({ integration }: IIntegrationListCardActionsProps) => {
    const { onDisconnect, onReconnect, onViewWebhook, availableIntegrationsForWebhook } =
      useIntegrationListContext()

    const dropdownItems = [
      ...(availableIntegrationsForWebhook.has(integration.key)
        ? [
            {
              id: 'webhook',
              label: 'View webhook',
              iconL: webhookIcon,
              onClick: () => onViewWebhook(integration),
            },
          ]
        : []),
      ...(integration.isConnectedSettingsAvailable
        ? [
            {
              id: 'settings',
              label: 'Settings',
              iconL: settingsIcon,
              onClick: () =>
                uiStore.changeRouteViaVue({
                  path: `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${integration.key}/${IntegrationsRoutes.settings}`,
                }),
            },
          ]
        : []),
      {
        id: 'reconnect',
        label: 'Reconnect',
        iconL: reconnectIcon,
        onClick: () => onReconnect(integration),
      },
      {
        id: 'disconnect',
        label: 'Disconnect',
        iconL: unlinkIcon,
        onClick: () => onDisconnect(integration),
      },
    ]

    return (
      <Dropdown
        typeButton={'icon-button'}
        icon={'settings'}
        placement={'bottom-end'}
        items={dropdownItems}
        width={200}
        iconButtonProps={{
          size: 'small',
          ariaLabel: 'IntegrationDropdown_button',
          variant: 'icon',
        }}
        ariaLabel={'IntegrationDropdown'}
      />
    )
  }
)
